// A chaque nouveau menu qui dispose de sous menu, penser à rajouter son name tel qu'il est écrit dans le fichier TopMenu affin de gérer l'apparition de son sous menu
export const adminNavigation = [
    {
        name: "Newsletters",
        type: "link",
        path: "",
        child: true,
        submenu: [
            {
                path: "/newsletter-list",
                name: "Liste des inscrits"
            }
        ]
    },
    {
        name: "Messagerie",
        type: "link",
        path: "",
        child: true,
        submenu: [
            {
                path: "/messagerie-list",
                name: "Liste des messages"
            }
        ]
    },
    {
        name: "Gestion des contenus",
        type: "link",
        path: "",
        child: true,
        submenu: [
            {
                path: "/evenement-liste",
                name: "Gestion des contenus"
            },
            {
                path: "/contenu/creation-tags",
                name: "Créer des tags"
            },
            {
                path: "/rubrique/list",
                name: "Gestion des rubriques"
            },
        ]
    },
    {
        name: "Gestion des comptes",
        type: "link",
        path: "",
        child: true,
        submenu: [
            {
                path: "/user/list",
                name: "Liste des comptes"
            },
        ]
    },
    {
        name: "Adhésions",
        type: "link",
        path: "",
        child: true,
        submenu: [
            {
                path: "/adhesion-list",
                name: "Liste des adhésions"
            }
        ]
    },
    {
        name: "Albums Photos",
        type: "link",
        path: "",
        child: true,
        submenu: [
            {
                path: "/albums-list",
                name: "Gestion des albums"
            }
        ]
    },
];